import PropTypes from "prop-types";
import { forwardRef } from "react";
import { StyledBugerMenu } from "./buger-menu.style";

const BugerMenu = forwardRef(({ onClick, $darkColors, ...props }, ref) => {
    return (
        <StyledBugerMenu
            onClick={onClick}
            onKeyDown={() => {}}
            className="burger-menu"
            role="button"
            tabIndex={0}
            ref={ref}
            $darkColors={$darkColors}
            {...props}
        >
            <div className="line line-1"></div>
            <div className="line line-2"></div>
            <div className="line line-3"></div>
        </StyledBugerMenu>
    );
});

BugerMenu.propTypes = {
    onClick: PropTypes.func,
    $darkColors: PropTypes.bool,
};
BugerMenu.displayName = "BugerMenu";

export default BugerMenu;
